
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Loader2 } from "lucide-react";

interface MessagingPlatformSelectProps {
  preferredMessaging: string;
  onPreferredMessagingChange: (value: string) => void;
  isSaving?: boolean;
}

export const MessagingPlatformSelect = ({ 
  preferredMessaging, 
  onPreferredMessagingChange,
  isSaving = false
}: MessagingPlatformSelectProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="messagingPreference">Preferred Messaging Platform</Label>
      <div className="flex items-center">
        <RadioGroup 
          value={preferredMessaging} 
          onValueChange={onPreferredMessagingChange}
          className="flex space-x-4"
          disabled={isSaving}
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="whatsapp" id="whatsapp" />
            <Label htmlFor="whatsapp" className="cursor-pointer">WhatsApp</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="telegram" id="telegram" />
            <Label htmlFor="telegram" className="cursor-pointer">Telegram</Label>
          </div>
        </RadioGroup>
        {isSaving && (
          <Loader2 className="ml-3 h-4 w-4 animate-spin text-gray-500" />
        )}
      </div>
    </div>
  );
};
